import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import mainlogogray from "./images/mainlogogray.png";

const styles = StyleSheet.create({
  page: {
    padding: 10,
    fontSize: 9,
    fontFamily: "Helvetica",
  },

  center: {
    textAlign: "center",
  },

  bold: {
    fontWeight: "bold",
  },

  divider: {
    borderBottomWidth: 1,
    borderBottomColor: "#C2C2C2",
    marginVertical: 4,
  },

  rowBetween: {
    flexDirection: "row",
    justifyContent: "space-between",
  },

  itemRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 2,
  },

  footer: {
    marginTop: 10,
    textAlign: "center",
  },

  // New styles for discount and totals
  discountRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 4,
    marginBottom: 2,
  },

  totalsSection: {
    marginTop: 8,
  },

  totalsRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 3,
  },
});

export default function InvoiceReceiptPdf({
  shopName = "PANTALA LUXURY PERFUMES",
  shopPhone = "0244770192 / 0266090979",
  invoiceData,
  customerData,
  items = [],
  total = 0,
  discount = 0,
  totalPaid = 0,
  remainingBalance = 0,
}) {
  // Calculate subtotal from items
  const subtotal = items.reduce((sum, item) => {
    const qty = Number(item.quantity || 0);
    const price = Number(item.unit_price || 0);
    return sum + qty * price;
  }, 0);

  // Calculate tax (if applicable - currently 0 in your WhatsApp format)
  const tax = 0;

  return (
    <Document>
      {/* 80mm thermal receipt */}
      <Page size={[226, 1000]} style={styles.page}>
        {/* HEADER */}
        {/* <Text style={[styles.center, styles.bold, { fontSize: 12 }]}>
          {shopName}
        </Text> */}
        <Image
          src={mainlogogray}
          alt="Shop Logo"
          style={{
            width: 80,
            height: 60,
            alignSelf: "center",
            paddingBottom: 8,
          }}
        />
        {/* <Text
          style={[styles.center, styles.bold, { fontSize: 12, marginTop: 4 }]}
        >
          {shopName}
        </Text> */}
        <Text style={styles.center}>Tel: {shopPhone}</Text>

        <View style={styles.divider} />

        {/* META */}
        <Text>
          <Text style={styles.bold}>Invoice#: </Text>
          {invoiceData?.attributes?.field_order_number}
        </Text>

        <Text>
          <Text style={styles.bold}>Date: </Text>
          {new Date(invoiceData?.attributes?.created).toLocaleString("en-GH")}
        </Text>

        <Text>
          <Text style={styles.bold}>Customer: </Text>
          {customerData?.name || "Walk-in"}
        </Text>

        <View style={styles.divider} />

        {/* ITEMS HEADER */}
        <View style={styles.rowBetween}>
          <Text style={styles.bold}>Item</Text>
          <Text style={styles.bold}>Total</Text>
        </View>

        <View style={styles.divider} />

        {/* ITEMS */}
        {items.map((item, index) => (
          <View key={index} style={{ marginBottom: 4 }}>
            <Text style={styles.bold}>{item.product_title}</Text>
            <View style={styles.itemRow}>
              <Text>
                {item.quantity} x GHC
                {Number(item.unit_price).toFixed(2)}
              </Text>
              <Text>GHC{Number(item.line_total).toFixed(2)}</Text>
            </View>
          </View>
        ))}

        <View style={styles.divider} />

        {/* PAYMENT SUMMARY - Added like WhatsApp */}
        <View style={styles.totalsSection}>
          {/* <Text style={[styles.bold, { marginBottom: 4 }]}>
            Payment Summary:
          </Text> */}

          {/* Items Subtotal */}
          <View style={styles.totalsRow}>
            <Text>Items Subtotal:</Text>
            <Text>GHC{subtotal.toFixed(2)}</Text>
          </View>

          {/* Discount (if any) */}
          {discount > 0 && (
            <>
              <View style={styles.discountRow}>
                <Text>Discount:</Text>
                <Text>- GHC{discount.toFixed(2)}</Text>
              </View>
              <View style={styles.totalsRow}>
                <Text></Text>
                <Text style={{ fontSize: 8 }}>
                  ({((discount / subtotal) * 100).toFixed(1)}% discount)
                </Text>
              </View>
            </>
          )}

          {/* Tax */}
          <View style={styles.totalsRow}>
            <Text>Tax:</Text>
            <Text>GHC{tax.toFixed(2)}</Text>
          </View>

          {/* Divider */}
          <View style={[styles.divider, { marginVertical: 4 }]} />

          {/* Total Amount */}
          <View style={styles.totalsRow}>
            <Text style={styles.bold}>Total Amount:</Text>
            <Text style={styles.bold}>GHC{total.toFixed(2)}</Text>
          </View>

          {/* Total Paid */}
          <View style={styles.totalsRow}>
            <Text>Total Paid:</Text>
            <Text>GHC{totalPaid.toFixed(2)}</Text>
          </View>

          {/* Balance Due */}
          <View style={styles.totalsRow}>
            <Text>Balance Due:</Text>
            <Text>GHC{remainingBalance.toFixed(2)}</Text>
          </View>
        </View>

        <View style={styles.divider} />

        {/* Footer message from WhatsApp */}
        <View style={styles.footer}>
          <Text style={{ marginBottom: 4 }}>Thank you for your business</Text>
          <Text>We hope to see you again soon!</Text>
        </View>

        <View style={[styles.divider, { marginTop: 8 }]} />

        {/* Additional footer */}
        {/* <View style={styles.footer}>
          <Text>Goods sold are not returnable</Text>
        </View> */}
      </Page>
    </Document>
  );
}
